import React from 'react';

import logoWhite from '../assets/proteorisk-logo-white.svg';
import logoGray from '../assets/proteorisk-logo-gray.svg';
import { useProteoRisk } from './context';

// The webserver family's welcome banner: logo, title and a one-line subtitle.
export default function Banner({ title, subtitle }) {
  const { theme } = useProteoRisk();
  return (
    <header className="PROTEORISK-home-header">
      <div className="PROTEORISK-welcome-container">
        <div className="PROTEORISK-welcome-logo-wrapper">
          <img src={theme === 'light' ? logoGray : logoWhite} alt="ProteoRisk" className="PROTEORISK-welcome-logo" />
        </div>
        <div className="PROTEORISK-welcome-text">
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </div>
      </div>
    </header>
  );
}
